import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch, useStore, computed } from '@nuxtjs/composition-api';
import { useRecurly, PlanInfo } from '~/composables/useRecurly';
import { State } from '~/store';
import {
  asRecurlyPlanCode,
  isRecurlyPlanCodeForLocation,
  RecurlyPlanCode,
  UserSubscriptionCode,
} from '~/types/plan';
import { User } from '~/types/user';
import { planFeatures } from '~/data/plan_selector_features';
import { plans as plansData } from '~/data/plans';
import { isLocale } from '~/types/locale';

interface Props {
  planCodes: RecurlyPlanCode[];
  currentPlan: UserSubscriptionCode;
  selectedPlan: RecurlyPlanCode;
}

interface Emits {
  (event: 'plan-selected', plan: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlanSelector',
  props: {
    planCodes: null,
    currentPlan: null,
    selectedPlan: null
  },
  emits: ["plan-selected"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'plan-selected', plan: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  planCodes: RecurlyPlanCode[];
  currentPlan: UserSubscriptionCode;
  selectedPlan: RecurlyPlanCode;
};



const store = useStore<State>();
const { getPlanInfoFromRecurly } = useRecurly();

const plan = ref(props.selectedPlan);
const plans = ref<PlanInfo[]>([]);
const isLoading = ref(true);
const location = computed(() => store.state.location);
const user = computed<User>(() => store.getters.loggedInUser);

watch(plan, () => emit('plan-selected', plan.value));
onMounted(() => initPlanInfo());

const getFeatureForPlan = (plan: RecurlyPlanCode) => {
  if (isRecurlyPlanCodeForLocation(plan, location.value.secondary)) {
    // Not ideal to use any but adds complexity when strongly typing this
    return (planFeatures[location.value.secondary] as any)[plan];
  }

  return planFeatures.au.essential_annual;
};

const initPlanInfo = async () => {
  for (const planCode of props.planCodes) {
    // Don't show current plan
    if (user.value.subscription && asRecurlyPlanCode(user.value.subscription.code) === planCode) {
      continue;
    }
    // Don't show free plan
    if (planCode === 'free') {
      continue;
    }
    try {
      const planInfo = await getPlanInfoFromRecurly(planCode, location.value.currency);
      plans.value.push(planInfo);
    } catch (e) {
      // If it errors we don't push the plan to the list
      console.error(e);
    }
  }

  isLoading.value = false;
};

const getPlanName = (plan: PlanInfo): string => {
  const planTitle = isLocale(location.value.secondary)
    ? plansData[location.value.secondary].find(p => p.code === plan.code)?.title
    : undefined;
  return planTitle || plan.name;
};

return { __sfc: true,props, emit, store, getPlanInfoFromRecurly, plan, plans, isLoading, location, user, getFeatureForPlan, initPlanInfo, getPlanName, asRecurlyPlanCode }
}

})